import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { Col, Row } from 'reactstrap';
import { updatePropertyInput, UIToggleBoolean } from '../PropertyActions';
import { HeadlineNumber } from '../../../components/UI/HeadlineNumber';
import { StackedChart } from './StackedChart';
import ResultsPanelTitle, { ResultsPanel, ResultsPanelBody, ResultsPanelRowText, ResultsPanelRow, ResultsPanelKPIRow, formatCurrency } from './ResultsPanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

class ResultsTable extends Component {
    displayName = ResultsTable.name

    constructor(props) {
        super(props);
        //this.handleRowToggle = this.handleRowToggle.bind(this);
        this.showWizard = this.showWizard.bind(this);
    }

    

    showWizard() {
        this.props.UIToggleBoolean("showReport");
    }

    render() {
        var showTaxCalc = (this.props.incomeNet >= 0) && !this.props.over150k;

        return (
            <div>
                <ResultsPanel name="UICollapseCashRequired" isOpen={this.props.UICollapseCashRequired}>
                    <ResultsPanelTitle  title="Purchase costs" value={this.props.purchaseCashRequired} />
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Deposit" value={this.props.deposit} />
                        <ResultsPanelRow title="Stamp duty" value={this.props.stampDuty} />
                        <ResultsPanelRow title="Other buying fees" value={this.props.otherBuyingFees} />
                        <ResultsPanelRow title="Refurbishment costs" value={this.props.costsRefurbishment} />
                    </ResultsPanelBody>
                </ResultsPanel>

                <ResultsPanel name="UICollapseGrossProfit" isOpen={this.props.UICollapseGrossProfit}>
                    <ResultsPanelTitle title="Gross profit" value={this.props.incomeNetBeforeInterest} addNegativeSymbol={this.props.incomeNetBeforeInterest < 0} suffix={" / y"}/>
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Rental income" value={this.props.income * 12} addPositiveSymbol={true} />
                        <ResultsPanelRow title="Management fees" value={0 - (this.props.costsMonthlyManagement * 12)} addNegativeSymbol={true} />
                        <ResultsPanelRow title="Bills" value={0 - (this.props.costsMonthlyBills * 12)} addNegativeSymbol={true} />
                        <ResultsPanelRow title="Other costs" value={0 - (this.props.costsMonthlyOther * 12)} addNegativeSymbol={true}/>
                    </ResultsPanelBody>
                </ResultsPanel>

                <ResultsPanel name="UICollapseMortgageDetails" isOpen={this.props.UICollapseMortgageDetails}>
                    <ResultsPanelTitle title="Mortgage payment" value={this.props.interest} suffix={" / y"}/>
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Mortgage balance" value={this.props.mortgageBalance} />
                        <ResultsPanelRow title="Interest rate" value={this.props.interestRate + '%'} format="none" />
                        <ResultsPanelRow title="Interest repayment" value={this.props.interest} />
                        <ResultsPanelRow title="LTV" value={this.props.ltv + '%'} format="none" />
                        <ResultsPanelRow title="Interest cover" value={this.props.interestCoverRatio} format="none" />
                    </ResultsPanelBody>
                </ResultsPanel>

                <ResultsPanel name="UICollapsePropertyReport" isOpen={this.props.UICollapsePropertyReport}>
                    <ResultsPanelTitle title="Net profit" value={this.props.incomeNet} addNegativeSymbol={this.props.incomeNet < 0} suffix={" / y"}/>
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Gross profit" value={this.props.incomeNetBeforeInterest} addPositiveSymbol={true} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Interest payment" value={0 - this.props.interest} addNegativeSymbol={true}/>
                    </ResultsPanelBody>
                </ResultsPanel>

                {this.props.goal === 'income' && 
                <ResultsPanel name="UICollapseTaxSPV" isOpen={this.props.UICollapseTaxSPV}>
                    <ResultsPanelTitle title="Earnings after tax (company held)" value={showTaxCalc ? this.props.taxProjectionSPV.netProfitReturned : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true} suffix={showTaxCalc ? " / y" : ""}/>
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Net profit" value={showTaxCalc ? this.props.incomeNet : 'n/a'} format={showTaxCalc ? '' : 'none'} addPositiveSymbol={true} addNegativeSymbol={true} />
                        <ResultsPanelRow title="Corporation tax" value={showTaxCalc ? (0 - this.props.taxProjectionSPV.corporationTax) : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Income tax" value={showTaxCalc ? (0 - this.props.taxProjectionSPV.incomeTax) : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Earnings after tax" value={showTaxCalc ? this.props.taxProjectionSPV.netProfitReturned : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true} />
                    </ResultsPanelBody>
                </ResultsPanel>
                }

                {this.props.goal !== 'income' && 
                <ResultsPanel name="UICollapseTaxSPV" isOpen={this.props.UICollapseTaxSPV}>
                    <ResultsPanelTitle testId="companyEarningsAfterTax" title="Earnings after tax (company held)" value={showTaxCalc ? (this.props.incomeNet - this.props.taxProjectionSPV.corporationTax) : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true} suffix={showTaxCalc ? " / y" : ""} />
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Net profit" value={showTaxCalc ? this.props.incomeNet : 'n/a'} format={showTaxCalc ? '' : 'none'} addPositiveSymbol={true} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Corporation tax" value={showTaxCalc ? (0 - this.props.taxProjectionSPV.corporationTax) : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true} />
                        <ResultsPanelRow title="Earnings after tax" value={showTaxCalc ? (this.props.incomeNet - this.props.taxProjectionSPV.corporationTax) : 'n/a'} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true}/>
                        <ResultsPanelRowText>
                            <p>
                                <em>
                                Note: if you'd like to personally draw down on this profit, 
                                you'll need to pay income tax{showTaxCalc ? " of " + formatCurrency(this.props.taxProjectionSPV.incomeTax) : '.'}
                                </em>
                            </p>
                        </ResultsPanelRowText>
                    </ResultsPanelBody>
                </ResultsPanel>
                }

                <ResultsPanel name="UICollapseTaxPersonal" isOpen={this.props.UICollapseTaxPersonal}>
                    <ResultsPanelTitle title="Earnings after tax (personally held)" value={showTaxCalc ? this.props.taxProjectionPersonal.netProfitReturned : "n/a"} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true} suffix={showTaxCalc ? " / y" : ""}/>
                    <ResultsPanelBody>
                        <ResultsPanelRow title="Net profit" value={showTaxCalc ? this.props.incomeNet : "n/a"} format={showTaxCalc ? '' : 'none'} addPositiveSymbol={true} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Income tax" value={showTaxCalc ? (0 - this.props.taxProjectionPersonal.incomeTax) : "n/a"} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true}/>
                        <ResultsPanelRow title="Earnings after tax" value={showTaxCalc ? this.props.taxProjectionPersonal.netProfitReturned : "n/a"} format={showTaxCalc ? '' : 'none'} addNegativeSymbol={true}/>
                    </ResultsPanelBody>
                </ResultsPanel>

     
                <a className="btn return-btn" onClick={this.showWizard}><FontAwesomeIcon icon={faChevronLeft} /> Previous</a>

                {/*<Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Cash required"
                            valuePounds={this.props.purchaseCashRequired}
                            value={this.props.purchaseCashRequired ? '' : 0}
                            description='Total cash required'
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Years to repay cash required"
                            value={this.props.yearsToRepayCashRequired || 0}
                            description='How much cash you invested'
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Gross yield"
                            value={this.props.yieldGross + '%'}
                            description='Gross yield'
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Interest cover ratio"
                            value={this.props.interestCoverRatio}
                            description='Interest cover ratio'
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="Capital growth"
                            valuePounds={this.props.growthCapitalTotal}
                            value={this.props.growthCapitalTotal ? '' : 0}
                            description='Capital growth'
                        />
                    </Col>
                    <Col sm="12" md="6">
                        <HeadlineNumber
                            title="LTV"
                            value={this.props.ltv + '%'}
                            description='Loan to value'
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="12">
                        <HeadlineNumber
                            title="ROI"
                            value={this.props.roi + '%'}
                            description='Return on investment'
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm="12">
                        <StackedChart
                            capital={this.props.growthCapitalByYear}
                            profit={this.props.incomeNet}
                        />
                    </Col>
                </Row>

                <Table className={'property-report'} >
                    <tbody>
                        <ResultsTableRow format={'none'} title="Years to repay cash required" value={this.props.yearsToRepayCashRequired} col={1} subtotal={true} />
                    </tbody>
                </Table>*/}
            </div>
                    
        );
    }

}

const mapStateToProps = state => {
    return state.property;
};


export default connect(
    mapStateToProps,
    { updatePropertyInput, UIToggleBoolean}
)(ResultsTable)


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/ResultsTable.jsx